import { DateTime } from "luxon";

export const makeNumberFormatter = options => {
    const formatter = new Intl.NumberFormat(undefined, options).format;
    //return value => typeof value == "number" ? formatter(value) : "-";
    return value => formatter(value ?? 0);
};

export const numberFormat = makeNumberFormatter({
    maximumFractionDigits: 1
});

export const roundFormat = makeNumberFormatter({
    maximumFractionDigits: 0
});

export const percentFormat = makeNumberFormatter({
    style: "percent",
    maximumFractionDigits: 2
});

export const percentFormat3 = makeNumberFormatter({
    style: "percent",
    maximumFractionDigits: 3
});

export const roundPercentFormat = makeNumberFormatter({
    style: "percent",
    maximumFractionDigits: 0
});

export const currencyFormat = makeNumberFormatter({
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0
});

export const currencyDecimalFormat = makeNumberFormatter({
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2
});

export const dateFormat = (date, defaultValue, opts = DateTime.DATE_SHORT) =>
    date
        ? (typeof date == "string"
              ? DateTime.fromISO(date, { zone: "utc" })
              : DateTime.fromJSDate(date)
          ).toLocaleString(opts)
        : defaultValue;
